import utils from 'utils'
class reportTemplateSettingCtrl {
    constructor($scope, sweetalert, $state, httpRequest, logger) {
        $scope.queryParam = {
            pageNum: 1,
            pageSize: 10,
            total: 0,
            param: {
                type: '1',
                contractNo: '', // 单据编号 ,
                contractType: '', // 合同类型（即合同模板名中业务名称）,
                createUser: '', // 创建用户(扫描人) ,
                startTime: '', // 开始时间 ,
                endTime: '', // 结束时间 ,
                invoiceCode: '',
                invoiceNumber: '',
                invoiceStatus: '',
            },
        }
        $scope.reset = function reset() {
            $scope.queryParam.param = {
                type: '1',
                contractNo: '', // 单据编号 ,
                contractType: '', // 合同类型（即合同模板名中业务名称）,
                createUser: '', // 创建用户(扫描人) ,
                startTime: '', // 开始时间 ,
                endTime: '', // 结束时间 ,
                invoiceCode: '',
                invoiceNumber: '',
                invoiceStatus: '',
            }
        }
        // $scope.reset()
        httpRequest.get_dictByTypeArr(['ivat_invoice_status']).then((res) => {
            Object.assign($scope.dictData, res.data.value)
        })
        // 选中合同信息
        $scope.selectedRows = []
        // let isSearch = false
        // $scope.$watch('queryParam', () => {
        //     isSearch = false
        // }, true)
        // $scope.$on('$stateChangeStart', (e, toState) => {
        //     if (toState.name.indexOf('input.electronImage.contractManagement') != -1) {
        //         isSearch && sessionStorage.setItem('contractManagementParam', JSON.stringify($scope.queryParam))
        //     }
        // })
        $scope.queryList = function queryList() {
            $scope.queryParam = sessionStorage.contractManagementParam ? JSON.parse(sessionStorage.contractManagementParam) : $scope.queryParam
            httpRequest.post_getIvatContractList($scope.queryParam).then((res) => {
                $scope.contractList = res.data.value.list
                $scope.queryParam.total = res.data.value.total
                $scope.queryParam.pageNum = res.data.value.pageNum
                $scope.selectedRows = []
            })
        }
        $scope.searchList = function () {
            sessionStorage.setItem('contractManagementParam', JSON.stringify($scope.queryParam))
            $scope.queryList()
        }
        // 分页
        $scope.pageChanged = function () { // 点击页码发起查询
            sessionStorage.setItem('contractManagementParam', JSON.stringify(
                {
                    pageNum: $scope.queryParam.pageNum,
                    pageSize: $scope.queryParam.pageSize,
                    param: sessionStorage.contractManagementParam ? JSON.parse(sessionStorage.contractManagementParam).param : {
                        type: '1',
                        contractNo: '', // 单据编号 ,
                        contractType: '', // 合同类型（即合同模板名中业务名称）,
                        createUser: '', // 创建用户(扫描人) ,
                        startTime: '', // 开始时间 ,
                        endTime: '', // 结束时间 ,
                        invoiceCode: '',
                        invoiceNumber: '',
                        invoiceStatus: '',
                    },
                },
            ))
            $scope.queryList()
        }
        function getContractTypeList() {
            httpRequest.post_getContractTemplateList({ pageNum: 1, pageSize: 100000, param: {} }).then((res) => {
                $scope.contractTemplates = res.data.value.list
            })
        }

        function init() {
            getContractTypeList()
            $scope.queryList()
        }
        init()

        $scope.tableDropdownConfig = [
            {
                label: '详情',
                handler(item) {
                    $state.go('input.electronImage.contractManagement.detail', {
                        contractId: item.contractId,
                        mode: 'readonly',
                    })
                },
                showWhile(item, hasPermit) {
                    return hasPermit('detail_contract_management')
                },
            },
            {
                label: '编辑',
                handler(item) {
                    $state.go('input.electronImage.contractManagement.edit', {
                        contractId: item.contractId,
                        mode: 'edit',
                    })
                },
                showWhile(item, hasPermit) {
                    return hasPermit('edit_contract_management')
                },
            },
            {
                label: '删除',
                handler(item) {
                    sweetalert.confirm('删除提醒', '确定删除合同信息和发票信息？').then(() => {
                        httpRequest.get_deleteContractAndInvoice(item.contractId).then(() => {
                            logger.logSuccess('删除成功')
                            $scope.queryList()
                        })
                    })
                },
                showWhile(item, hasPermit) {
                    return hasPermit('delete_contract_management')
                },
            },
        ]

        $scope.exportImages = function exportImages() {
            // httpRequest.get_exportContractToZip({
            //     accessToken: localStorage.getItem('id_token'),
            //     ...$scope.queryParam.param,
            // }) 
            const reqObj = $.extend({}, $scope.queryParam.param, {
                selectedIdList: $scope.selectedRows.map(x => x.contractId)
            })
            let _url = `${host.etcloudIvatApp}contract/ivatContractOperate/exportToZip?accessToken=${localStorage.getItem('id_token')}`
            utils.post_downLoad(reqObj, _url)
        }

        $scope.exportContract = function exportContract() {
            // httpRequest.get_exportContractToExcel({
            //     accessToken: localStorage.getItem('id_token'),
            //     ...$scope.queryParam.param,
            // })
            const reqObj = $.extend({}, $scope.queryParam.param, {
                selectedIdList: $scope.selectedRows.map(x => x.contractId)
            })
            let _url = `${host.etcloudIvatApp}contract/ivatContractOperate/exportToExcel?accessToken=${localStorage.getItem('id_token')}`
            utils.post_downLoad(reqObj, _url)
        }
    }
}

reportTemplateSettingCtrl.$inject = ['$scope', 'sweetalert', '$state', 'httpRequest', 'logger']

export default reportTemplateSettingCtrl



// WEBPACK FOOTER //
// ./src/app/input/electronImage/contractManagement/contractManageListCtrl.js